import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { getTeacherPendingEarnings, getTeacherWithdrawals, getTeacherLifetimeEarnings } from "../../../../store/actions/teacher";
import BalanceSheet from "./BalanceSheet";
import WithdrawalStatus from "./WithdrawalStatus";
import YourEarnings from "./YourEarnings";
import { toast } from "react-toastify";
import styles from "./styles.module.css";

const TeacherEarnings = () => {
  const dispatch = useDispatch();
  const teacherData = JSON.parse(localStorage.getItem("teacherData"));
  const [withdrawals, setWithdrawals] = useState([]);
  const [teacherPending, setTeacherPending] = useState(0);
  const [lifetimeEarnings, setLifetimeEarnings] = useState(0);

  const getWithdrawals = useCallback(async () => {
    try {
      const data = await dispatch(getTeacherWithdrawals());
      if (data?.success) setWithdrawals(data.data);
      else toast.error("Failed to fetch withdrawals");
    } catch (e) {
      console.error("Fetch withdrawals failed:", e);
      toast.error("Failed to fetch withdrawals");
    }
  }, [dispatch]);

  const getTeacherPending = useCallback(async () => {
    try {
      const data = await dispatch(getTeacherPendingEarnings());
      if (data?.success) setTeacherPending(data.data);
      else toast.error("Failed to fetch pending earnings");
    } catch (e) {
      console.error("Fetch pending earnings failed:", e);
      toast.error("Failed to fetch pending earnings");
    }
  }, [dispatch]);

  const getLifetimeEarnings = useCallback(async () => {
    try {
      const data = await dispatch(getTeacherLifetimeEarnings());
      if (data?.success) setLifetimeEarnings(data.data);
    } catch (e) {
      console.error("Fetch lifetime earnings failed:", e);
    }
  }, [dispatch]);

  useEffect(() => {
    getWithdrawals();
    getTeacherPending();
    getLifetimeEarnings();
  }, [getWithdrawals, getTeacherPending, getLifetimeEarnings]);

  return (
    <div className={styles.mainSection}>
      <div className={styles.section_first}>
        <YourEarnings pending={teacherPending} lifetime={lifetimeEarnings} />
        <WithdrawalStatus teacherData={teacherData || {}} handleWithdrawals={getWithdrawals} handlePending={getTeacherPending} />
      </div>
      <div className={styles.section_second}>
        <BalanceSheet data={withdrawals} handleFunction={getWithdrawals} />
      </div>
    </div>
  );
};

export default TeacherEarnings;
